import VarablePreview from "./VariablePreview";

export default VarablePreview;